import Dialog from '@mui/material/Dialog';

import { Container, ScrollContent } from './styles';
import Close from '../../assets/close.svg';
import { Slide, SlideProps, useMediaQuery } from '@mui/material';
import theme from '../../styles/theme';

import { FontAwesomeIcon as FAIcon } from "@fortawesome/react-fontawesome";
import { faClose } from '@fortawesome/free-solid-svg-icons';

interface Props {
  open: boolean;
  onClose?: () => void;
  primary?: boolean;
  color?: string;
  titleLeft?: React.ReactNode;
}

const Modal: React.FC<React.PropsWithChildren<Props>> = ({ children, open, onClose = () => {/* Do nothing */ }, primary, color, titleLeft }) => {
  const isDesktop = useMediaQuery('(min-width: 770px)');

  const handleClose = () => {
    onClose();
  };

  return (
    (<Dialog
      TransitionComponent={Slide}
      TransitionProps={{ direction: 'up' } as SlideProps}
      fullScreen={!isDesktop ? true : false}
      style={isDesktop ? {} : {
        paddingTop: 48
      }}
      PaperProps={{
        style: {
          ...(isDesktop ? {
            boxShadow: '6px 6px #000',
            border: '1px solid #000',
            borderRadius: 22,
            overflow: 'hidden',
            // width: '100%',
          } : {
            borderRadius: '22px 22px 0px 0px',
          }),
          ...(primary ? { backgroundColor: theme.colors.primary.main, boxShadow: '6px 6px ' + theme.colors.primary.main } : {}),
          ...(color ? { backgroundColor: color, boxShadow: '5px 5px black, 6px 6px ' + color + ', 8px 8px 8px ' + color } : {}),
        }
      }}
      onClose={handleClose}
      aria-labelledby="modal"
      open={open}
    >
      <Container>
        <div style={{ display: 'flex', flexDirection: 'row', padding: 0, paddingLeft: 28, width: '100%', textAlign: 'right' }}>
          <div style={{ flex: 1, textAlign: 'left' }}>
            {titleLeft && titleLeft}
          </div>
          <button type="button" onClick={onClose}>
            <FAIcon icon={faClose} style={{ color: 'black', fontSize: 20, marginTop: 10, marginRight: 10 }} />
          </button>
        </div>
        <ScrollContent>{children}</ScrollContent>
      </Container>
    </Dialog>)
  );
};

export default Modal;
